import { ListLayout } from 'components/common/ListLayout'
import React from 'react'
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { assignTranslators } from 'slices/inviteTranslatorSlice';
import { fetchTranslationView } from 'slices/inviteTranslatorSlice';
import { fetchInvitedTranslators } from 'slices/inviteTranslatorSlice';
import { inviteTranslatorsSelector } from 'slices/inviteTranslatorSlice';
import { removeInvitedTranslators } from 'slices/inviteTranslatorSlice';
import Swal from 'sweetalert2';
import CustomTranslationWorkOrderModal from 'components/translation/CustomTranslationWorkOrderModal';

const AppointedTranslatorsList = ({ itemId, fetchTranslation, height }) => {
    const dispatch = useDispatch()
    const { last_page: totalPages, loader, invitedTranslators } = useSelector(inviteTranslatorsSelector);
    const translation = invitedTranslators?.translation_invites
    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}

    });
    const refAddutton = React.useRef(null);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [deleteModal, setDeleteModal] = React.useState(false);

    const fetchData = async () => {
        dispatch(fetchInvitedTranslators(itemId))
    };

    React.useEffect(() => {
        fetchData();
    }, [itemId]);


    const handleAddInviteTranslatorPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };

    const hideConfirmDialog = () => {
        setDeleteModal(false);
    }
    const handleSubmitInviteTranslators = React.useCallback(() => {

        const submitCallback = (status, message) => {
            if (status) {
                toast.success(message, {
                    className: "successToast",
                })
                setSelectedItems([]);
                setSelectAll(false)
                dispatch(fetchTranslationView(itemId))
                hideConfirmDialog()
            }
            else {
                toast.error(message,
                    {
                        className: "errorToast",
                    }
                );
            }
        };
        new Swal({
            title: "Are you sure?",
            text: "You want to Remove them?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!"
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(removeInvitedTranslators({ translator_ids: selectedItems, }, itemId, submitCallback))
            }
        })
    }, [selectedItems])

    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    const handleToggleSelectAll = React.useCallback(() => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
        setSelectedItems(translation.map((inviteTranslator) => inviteTranslator.id.toString()))
    }, [selectedItems, selectAll, translation])

    const onAssign = (iterp_id) => {

        Swal.fire({
            title: "Confirmation",
            text: "Are you sure, you want to assign?",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            showCancelButton: true,
        }).then(({ isConfirmed, }) => {
            if (isConfirmed) {
                const callBack = (success) => {
                    if (success) {
                        fetchData()

                        toast.success("Assigned Successfully ", {
                            className: "successToast",
                        })
                    } else {

                    }
                };
                const payload = {
                    interpreter_id: iterp_id
                }
                dispatch(assignTranslators(payload, itemId, callBack));
            }
        })
    }

    const renderTableHeader = React.useCallback(() => {

        return (
            <tr>
                <th className="col-1">
                    <div className="row_check">
                        <span>#</span>
                        <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
                    </div>
                </th>

                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Name</p>
                    </div>
                </th>
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Email</p>
                    </div>
                </th>
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Phone</p>
                    </div>
                </th>
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Languages</p>
                    </div>
                </th>

                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Invite Status</p>
                    </div>
                </th>
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Actions</p>
                    </div>
                </th>
            </tr>
        )
    }, [selectedItems, translation])


    const renderTableContent = React.useCallback(() => {
        return (
            translation?.map((item, index) => {
                return <AppointedIntepreterItem item={item} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddInviteTranslatorPopUp} onAssign={onAssign} translationStatus={invitedTranslators?.status} />
            })
        )
    }, [translation, selectedItems]);

    const handleClose = React.useCallback(() => {
        refAddutton.current.click();
        setAddForm({ show: false })
    }, [])


    const showConfirmDialog = () => {
        setDeleteModal(true);
        return
    };
    const renderFooter = React.useCallback(() => {
        return (
            <div className="row-primary">

                <button
                    onClick={handleSubmitInviteTranslators}
                    disabled={selectedItems?.length == 0}
                    className="main_button"
                    style={{

                        // float: "right",
                        marginRight: 20
                    }}
                >
                    Remove Translators
                </button>
            </div>
        )
    }, [selectedItems])
    return (
        <>
            <ListLayout
                title="Invited Translators - Email"
                addButtonDisabled={true}
                buttonTitle="Add InviteTranslator"
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                totalPages={totalPages}
                fetchList={fetchData}
                height={height}
                selectedItems={selectedItems}
                // handleRemoveItems={handleRemoveItems}
                // renderAddForm={<AddInviteTranslator item={addForm.item} show={addForm.show} onClose={handleClose} />}
                refAddutton={refAddutton}
                addForm={addForm}
                showConfirmDialog={showConfirmDialog}
                handleAddPopUp={handleAddInviteTranslatorPopUp}
                // renderFooter={renderFooter}
                hideRemoveButton={true}
                // loader={loader}
                hidePageLength={true}
                hidePagination={true}
                hideSearchBar={true}
                showRemoveOnTop={true}
                containerStyle={{
                    marginTop: 20
                }}
                time={false}

            >


                {/* {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />} */}

                {/* <AddInviteTranslator item={addForm.item} show={addForm.show} refAddutton={refAddutton} onClose={handleClose} /> */}
            </ListLayout>
            {/* Create full page Loader */}

        </>
    )

};

const AppointedIntepreterItem = ({
    item, index, selectedItems, handleChange, onAssign, translationStatus
}) => {
    const dispatch = useDispatch();


    const [customWorkOrderModal, setCustomWorkOrderModal] = React.useState({
        show: false,
        item: null,
    });

    const handleCloseWorkOrderModal = () => {
        setCustomWorkOrderModal({ show: false, item: null });
    };

    const handleCustomWorkOrder = () => {
        setCustomWorkOrderModal({ show: true, item });
    };

    const handleWorkOrderSuccess = () => {
        dispatch(fetchInvitedTranslators(item?.translation_id));
    };

    return (
        <>
            <CustomTranslationWorkOrderModal
                item={customWorkOrderModal.item}
                show={customWorkOrderModal.show}
                onClose={handleCloseWorkOrderModal}
                onSuccess={handleWorkOrderSuccess}
            />
        <tr>
            <td>
                <div className="row_check">
                    <span>{index + 1}</span>
                    <label className="custom-checkbox checkbox">
                        <input type="checkbox" name="select-all" data-value={item?.interpreter?.id} checked={selectedItems.includes(item?.interpreter?.id?.toString())} onChange={handleChange} />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </td>

            <td>
                {item?.interpreter?.first_name + " " + item?.interpreter?.last_name}
            </td>
            <td>
                {item?.interpreter?.user?.email}
            </td>
            <td>
                {item?.interpreter?.phone}
            </td>
            <td>
                {item?.interpreter?.languages?.map(l => l?.language?.name + ", ")}
            </td>

            <td className='text-transform-capitalize'>
                {item?.status}
            </td>
            <td>
                <div className='d-flex gap-2'>
                    {(translationStatus === "Translators Invited" && item?.status === "accepted") && (
                        <>
                            <button 
                                className="main_button" 
                                onClick={handleCustomWorkOrder}
                            >
                                Custom Work Order
                            </button>
                            <button 
                                className="main_button seagreen" 
                                onClick={() => onAssign(item?.interpreter.id)}
                            >
                                Assign
                            </button>
                        </>
                    )}
                </div>
            </td>
        </tr>
        </>
    )
}


export default AppointedTranslatorsList